import { Link } from 'react-router-dom'
import { User } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

/** Header entry-point to the profile/settings page (only when signed in). */
const ProfileButton = ({ className = '' }) => {
  const { user } = useAuth()
  if (!user) return null
  return (
    <Link
      to="/profile"
      aria-label="Profile"
      data-testid="profile-link"
      title={user.name || 'Profile'}
      className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#4a3d66] shadow-celebrate-sm transition-all duration-200 hover:-translate-y-0.5 hover:text-[#ff4d8d] hover:shadow-celebrate-md motion-reduce:transition-none motion-reduce:hover:translate-y-0 dark:bg-[#1e1438] dark:text-[#c3b8dd] dark:hover:text-white ${className}`.trim()}
    >
      <User className="w-4 h-4" />
    </Link>
  )
}

export default ProfileButton
